import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Form from 'deltoid/core/Form';
import { Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';
import { Body, Small } from 'deltoid/core/Blocks/Typography';
import { useForm, ErrorMessage } from 'react-hook-form';

import { aadharRegex } from '@utils/validations';
import {
  dialogActions,
  merchantSelectors,
  kycActions,
  kycSelectors,
} from '@store/ducks';

const GetOTP = ({
  closeDialog,
  aadharGetOtp,
  errMsgAadharGetOtp,
  aadharGetOtpProcessing,
  signingAuthorityDetails,
}) => {
  const { register, errors, handleSubmit, setError } = useForm();

  useEffect(() => {
    if (errMsgAadharGetOtp) setError('aadharNumber', 'apiErr', errMsgAadharGetOtp);
  }, [errMsgAadharGetOtp]);

  const onSubmit = (formData) => aadharGetOtp(formData.aadharNumber);

  const { name } = (
    signingAuthorityDetails
    && signingAuthorityDetails[0]
  ) || { name: 'NA' };
  return (
    <form onSubmit={handleSubmit(onSubmit)} data-testid='get-otp-aadhar-xml-form'>
      <Row noGutters>
        <Col>
          <Body
            variant='bold'
            className='p-3 border-bottom'
          >
            Fetch your KYC details using your Aadhaar number
          </Body>
          <Form.Group className='p-3'>
            <Form.Label id='aadharNumber'>
              Aadhar Card Number of ‘{name}’
            </Form.Label>
            <Form.Text
              ref={register({
                required: 'This field can not be empty',
                validate: {
                  regex: aadharRegex
                }
              })}
              id='aadharNumber'
              name='aadharNumber'
              placeholder='e.g 1477 2890 2999'
            />
            <ErrorMessage errors={errors} name={'aadharNumber'}>
              {({ message }) => (
                <Form.Message type='error'>
                  {message}
                </Form.Message>
              )}
            </ErrorMessage>
          </Form.Group>
          <div className='co-bg-yellow-tint p-3 m-3'>
            <Small>
              Note: Make sure this Aadhar number is linked to your registered mobile
              {' '}number. An OTP will be sent to registered number.
            </Small>
          </div>
          <div className='d-flex justify-content-between p-3 border-top'>
            <Form.Button className='bg-white border text-dark' type='button' onClick={closeDialog}>
              Go Back
            </Form.Button>
            <Form.Button type='button' onClick={handleSubmit(onSubmit)} disabled={aadharGetOtpProcessing} loading={aadharGetOtpProcessing}>
              Get OTP
            </Form.Button>
          </div>
        </Col>
      </Row>
    </form>
  )
};

const mapStateToProps = (state) => ({
  errMsgAadharGetOtp: kycSelectors.errMsgAadharGetOtp(state),
  aadharGetOtpProcessing: kycSelectors.aadharGetOtpProcessing(state),
  signingAuthorityDetails: merchantSelectors.getSigningAuthorityDetails(state),
});

const mapDispatchToProps = dispatch => ({
  closeDialog: () => dispatch(dialogActions.close()),
  aadharGetOtp: (aadharNumber) => dispatch(kycActions.aadharGetOtp(aadharNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GetOTP);
